'use client';

import type { DividerConfig, ReceiptSettings } from '@/lib/templates/schema';

interface DividerSectionProps {
  config: DividerConfig;
  settings: ReceiptSettings;
}

// Get the character pattern for each divider style
function getDividerPattern(style: string): string {
  switch (style) {
    case 'solid': return '─'; // Unicode box-drawing horizontal line
    case 'dashed': return '-';
    case 'dotted': return '·';
    case 'double': return '═';
    case 'equals': return '=';
    case 'dots': return '.';
    case 'colons': return ':';
    case 'stars': return '*';
    case 'spaces': return ' ';
    case 'none': return '';
    default: return '-';
  }
}

export function DividerSection({ config, settings }: DividerSectionProps) {
  const pattern = getDividerPattern(config.style);
  
  if (!pattern) {
    return (
      <div
        className="receipt-section"
        style={{
          paddingTop: config.spacing / 2,
          paddingBottom: config.spacing / 2,
        }}
      />
    );
  }

  return (
    <div
      className="receipt-section"
      style={{
        paddingTop: config.spacing / 2,
        paddingBottom: config.spacing / 2,
        fontFamily: settings.font,
        fontSize: settings.fontSize,
        color: settings.textColor,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
    >
      {pattern.repeat(100)}
    </div>
  );
}
